import React from 'react'
import siddheswaribastralaya from "../images/LOGO_BALAJI SAREE new.jpg";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  return (
    <div>

      <div className='fixed-top'>

        <div className="siddheswaribastralaya">
          <div className="album py-1">

            <div className="container">

              <div className="row ">

                <div className="col-md-10" >
                  <div className="d-flex justify-content-between align-items-center">

                    {/* <a className="appbuttonmanmohinicall me-5" href="https://g.co/kgs/eFXcipT"> Aistala, Ranaghat Showroom Direction <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sign-merge-right" viewBox="0 0 16 16">
  <path d="M8.75 6v1q.211.451.588.95c.537.716 1.259 1.44 2.016 2.196l-.708.708-.015-.016c-.652-.652-1.33-1.33-1.881-2.015V12h-1.5V6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41z"/>
  <path fill-rule="evenodd" d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"/>
</svg></a> */}


                    <marquee>
                      <a style={{ color: "#980000" }} className='bold'>বিয়ের কেনাকাটায় ঐতিহ্যের বিশ্বস্ত ঠিকানা… বালাজী শাড়ি। রানাঘাট:- 09064837572, বেথুয়াডহরী:- 9144500550, করিমপুর:- 7718500550  </a>
                    </marquee>

                  </div>

                </div>

                <div className="d-flex justify-content-between align-items-center">

                </div>
              </div>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-expand-lg navbar-white bg-white shadow">
          <div className="container-fluid">
            <Link to="/">
              <img src={siddheswaribastralaya} width="190px" height="39px" alt='siddheswari-bastralaya' />
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <div className='text'>
                    <Link to="/" className="nav-link" aria-current="page" href="#">HOME</Link>
                  </div>
                </li>
                <div className='text'>
                  <li className="nav-item dropdown">

                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      OUR SHOWROOM
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li><a className="dropdown-item" href="Ranaghat_showroom">Ranaghat</a></li>
                      <li><a className="dropdown-item" href="Bethuadahari_showroom">Bethaudahari</a></li>
                         <li><a className="dropdown-item" href="KarimpurShowroom">Karimpur</a></li>
                      

                    </ul>
                  </li>
                </div>
                <li className="nav-item">
                  <div className='text'>
                    <Link to="/womens-wear" className="nav-link" aria-current="page" href="#">WOMENS WEAR</Link>
                  </div>
                </li>
                <li className="nav-item">
                  <div className='text'>
                    <Link to="/mens-wear" className="nav-link" aria-current="page" href="#">MENS WEAR</Link>
                  </div>
                </li>
                <li className="nav-item">
                  <div className='text'>
                    <Link to="/Kidsware" className="nav-link" aria-current="page" href="#">KIDS WEAR</Link>
                  </div>
                </li>

                <li className="nav-item">
                  <div className='text'>
                    <Link to="/Contactus" className="nav-link" aria-current="page" >CONTACT US</Link>
                  </div>
                </li>
              </ul>
              <a href='tel: 9064837572'>
                <button className="navenqueries" type="submit">Help Line No.</button>
              </a>
            </div>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Navbar